import { eventChannel, END } from 'redux-saga'
import { call, cancelled, delay, put, select, take, takeLatest } from "redux-saga/effects";
import actionTypes from '../../actions/actionTypes';
import { sessionAliveBypassCall, sessionAliveCall } from '../../apis/wpApi/apiCalls';
import authUser from '../../apis/wpApi/authUser';
import { checkIsExpired, getSessionExpired, isSessionAlive } from '../authSaga/sessionHelpers';
// import { LOAD_ALL } from '../../constants/state';

// export const getDataLoadedAll = state => state.getIn([LOAD_ALL]).toJS()


const CHECK_ALIVE_EVERY = 5000


function intervallUntilExpired(expired) {
    return eventChannel(emitter => {
        const iv = setInterval(() => {
            const isExpired  = checkIsExpired(expired + 30, 0)

            if(isExpired) {
                emitter(END)
            } else {
                emitter(expired)
            }
        }, CHECK_ALIVE_EVERY)

        return () => {
          clearInterval(iv)
        }
    })
}


function* callAlive(bypass) {
    try {
        let response = false
        const token = yield call(authUser.getToken)

        if(bypass)  {
            response = yield call(sessionAliveBypassCall, token)
        } else {
            response = yield call(sessionAliveCall, token)
        }

        // const response = yield call(sessionAliveCall, token)

        if(
            response &&
            response.hasOwnProperty('status') &&
            200 === response.status &&
            response.hasOwnProperty('data') &&
            response.data &&
            Number.isInteger(response.data)
        ) {
            yield put({
                type: actionTypes.AUTH_SET_SESSION_DATA_ALIVE,
                payload: {
                    aliveUntil: response.data
                }
            })
        }
    } catch(e) {
        if(
            e &&
            e.hasOwnProperty('code') &&
            "ERR_NETWORK" === e.code
        ) {
            const isAlive = yield call(isSessionAlive)

            if(!isAlive) {
                yield put({
                    type: actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT
                })

                throw new Error('Session not alive anymore')
            }
        } else {
            yield put({
                type: actionTypes.AUTH_FLOW_LOGOUT_REQUEST_CLIENT
            })

            throw new Error('Can not refresh alive')
        }
    }
}


function* sessionIsAlive() {
    yield delay(CHECK_ALIVE_EVERY / 2)

    const { expired, bypass } = yield select(getSessionExpired)
    const chan = yield call(intervallUntilExpired, expired)

    // if(bypass) {
    //     return
    // }

    try {
        while (true) {
            yield take(chan)
            yield call(callAlive, bypass)
        }
    } catch(e) {
        chan.close()
    } finally {
        if(yield cancelled()) {
            chan.close()
        }
    }
}


function* sessionIsAliveSaga () {
    yield takeLatest([actionTypes.AUTH_FLOW_SUCCESS, actionTypes.AUTH_CHECK_SUCCESS], sessionIsAlive)
}

export default sessionIsAliveSaga